module.exports = __webpack_public_path__ + "img/pleisure_bodyimage01-4.b858ca98.jpg";